import { GendersList } from '@gtpl/shared-models/gtpl';
import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";

@Entity('user_fb')
export class FBEntity {
  
  @PrimaryGeneratedColumn("increment",{name:'id'})
  Id:number;
  @Column("varchar",{
    nullable:false,
    length:500,
    name:"user_page_id"
  })
  userPageId:string;
  @Column("varchar",{
    nullable: true,
    length:500,
    name:"page_name"
  })
  pageName:string;
  @Column("varchar",{
    nullable: false,
    length:500,
    name:"access_token"
  })
  accessToken:string;
  @Column({
    nullable:false,
    name: "page_ind",
    type:'int'
  })
  pageIndicator: number;
  @Column("int",{
    nullable: false,
    name:"created_by"
  })
  createdBy:number;
  @Column("boolean",{
    nullable:false,
    default:true,               
    name:"status" 
  })
  status:boolean;
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;
  
 

}
